export default "__VITE_ASSET__oobA9ZoW__"